<template>
  <v-dialog
    v-model="dialog"
    overlay
    persistent
    max-width="350px"
    transition="dialog-transition"
  >
    <template #activator="{ attrs }">
      <v-btn
        :loading="searching"
        @click="OpenOption"
        v-bind="attrs"
        icon
        color="success"
      >
        <v-icon>fas fa-users-cog</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense primary-title>
        <v-toolbar-title class="text-truncate">
          <strong class="blue--text">{{
            expenseInfo.PropertyName
          }}</strong></v-toolbar-title
        >

        <v-spacer></v-spacer>

        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-list>
          <v-subheader>{{ `${expenseInfo.type}` }}</v-subheader>
          <v-list-item>
            <Payment
              :BaseURL="BaseURL"
              :Onfinsh="OpenOption"
              :ExpBalance="Balance"
              :propertyInfo="expenseInfo"
            ></Payment>
          </v-list-item>
        </v-list>

        <!-- <p v-if="ErrMsg" v-html="ErrMsg" class="text-center error--text"></p> -->
        <!-- <v-divider></v-divider> -->
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <!-- <p>
        </p> -->
        <v-spacer></v-spacer>
        <cashDisplay
          small
          :isloading="searching"
          :Balance="Balance"
        ></cashDisplay>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
// import cashDisplay from "@/components/util/displayCash.vue";
export default {
  components: {
    Payment: () => import("./payProperty"),
    cashDisplay: () => import("@/components/coman/cashViewNoRow.vue"),
  },
  props: {
    expenseInfo: { type: Object, required: true },
    BaseURL: { type: String, required: true },
  },
  data() {
    return {
      ErrMsg: "",
      searching: false,
      dialog: false,
      ExpBalance: [],
    };
  },

  computed: {
    ...mapGetters(["UsersToken"]),
    Balance() {
      return this.ExpBalance.map(Amount => {
        if (Amount.Amount < 0) return { ...Amount, AccountName: "Advanced" };
        return { ...Amount, AccountName: "Balance" };
      });
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";
      this.ExpBalance = [];
    },

    GetReq(url, query) {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    OpenOption() {
      this.searching = true;
      this.ExpBalance = [];
      let cashUrl = this.BaseURL + "/balance";
      let cashQuery = {
        _id: this.expenseInfo._id,
        type: this.expenseInfo.PropertyType,
      };
      this.GetReq(cashUrl, cashQuery)
        .then(blce => {
          // console.log(blce.data);
          this.ExpBalance = blce.data || [];

          this.dialog = true;
          this.searching = false;
        })
        .catch(err => {
          console.log(err);
          this.searching = false;
        });
    },
  },
};
</script>
